import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setItemType } from 'reducers/landDevReducer';
import LandDevMap from './LandDevMap';
import ParcelTable from '../../../../common/advance-table/ParcelTable';
import Develop from '../develop';

const SelectLand = ({ currentState, errors, setError, clearErrors }) => {
  const editRef = useRef(null);
  const dispatch = useDispatch();

  const setEditRef = ref => {
    editRef.current = ref;
  };

  const handleDrawButtonClick = itemType => {
    dispatch(setItemType(itemType));
    editRef.current._toolbars.draw._modes.polygon.handler.enable();
  };

  const { selectedLandParcels } = useSelector(state => state.landDev);

  return (
    <>
      <Row className="g-3 mb-3 h-100">
        <Col lg={6}>
          <LandDevMap currentState={currentState} onEditMounted={setEditRef} />
        </Col>
        <Col lg={6} className="text-center">
          {currentState === 1 && (
            <ParcelTable
              errors={errors}
              setError={setError}
              clearErrors={clearErrors}
              selectedLandParcels={selectedLandParcels}
            />
          )}
          {currentState === 2 && (
            <Develop onDrawPolygon={handleDrawButtonClick} />
          )}
        </Col>
      </Row>
    </>
  );
};

SelectLand.propTypes = {
  currentState: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired
};

export default SelectLand;
